import React, { useState } from 'react';

import { remCss, scssVariables as variables, api } from 'src/helpers';

const cachedApiImages = {};

const Avatar = React.memo(
  ({
    onClick,
    onlineState,
    image,
    text,
    background = variables['colors-mc-primary'],
    width = 40,
    height = 40,
    username = null,
    live,
    labelLive = true,
    square = false,
    userId
  }) => {
    let [apiImage, setApiImage] = useState(false);
    let [apiImageLoading, setApiImageLoading] = useState(false);
    if (userId && !image && !apiImage && !apiImageLoading) {
      if (cachedApiImages[userId]) {
        image = cachedApiImages[userId];
      } else {
        setApiImageLoading(true);
        api('profile/get/avatar', { id: userId }).then(({ data }) => {
          if (data && data.avatar) {
            cachedApiImages[userId] = data.avatar;
            setApiImage(data.avatar);
          }
        });
      }
    }

    if (apiImage) image = apiImage;

    let iconColor = '';
    switch (onlineState) {
      case 'online':
        iconColor = 'primary';
        break;
      case 'not_available':
        iconColor = 'quaternary';
        break;
    }

    return (
      <div
        className={'mc-avatar ' + (live ? 'mc-live ' : ' ') + (username ? ' mc-pointer' : '')}
        onClick={onClick}
        style={{
          width: remCss(width),
          minWidth: remCss(width),
          height: remCss(height),
          minHeight: remCss(height)
        }}
      >
        {onlineState && (
          <div
            className={'mc-avatar-online-icon'}
            style={{ backgroundColor: variables[`colors-mc-${iconColor}`] }}
          />
        )}
        <div
          className={'mc-avatar-picture ' + (square ? 'square' : '')}
          style={{ backgroundColor: background }}
        >
          {image ? (
            <img src={image} alt='' />
          ) : (
            <span style={{ fontSize: remCss(width) * 0.4 }}>
              {text && text.charAt(0).toLocaleUpperCase()}
            </span>
          )}
        </div>
        {live && labelLive && <div className={'mc-live-label'}>LIVE</div>}
      </div>
    );
  }
);
Avatar.displayName = 'Avatar';

export default Avatar;
